// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum AccountingDocumentSearchPermissibility {
  SearchPermitted = "SEARCH_PERMITTED",
  SearchDenied = "SEARCH_DENIED",
}
export default AccountingDocumentSearchPermissibility;
